import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../core/api.service';
import { UserService } from '../core/user.service';
import { LoggerService } from '../core/logger.service';
import { ErrCode } from '../shared/models';

@Component({
  selector: 'app-pay-invoice',
  templateUrl: './pay-invoice.component.html',
  styleUrls: ['./pay-invoice.component.scss']
})
export class PayInvoiceComponent implements OnInit {
  protected errCode: ErrCode;
  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private loggerService: LoggerService
  ){}

  ngOnInit(): void {
    this.payInvoice();
  }

  private async payInvoice() {
    try {
      const user_id = this.userService.get('id');
      const result = await this.apiService.execute('getchargebeerenewurl', {
        user_id,
        type: 'pay_invoice'
      }) as any;
      window.location.href = result.renew_url;
    } catch (error) {
      this.loggerService.error(error);
      this.errCode = ErrCode.fromException(error);
    }
  }
}
